module.exports = __webpack_public_path__ + "static/media/logo_credcrea.dabdd2d8.svg";